import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/home/HeroSection';
import { ServicesOverview } from '../components/home/ServicesOverview';
import { ClientTypesSection } from '../components/home/ClientTypesSection';
import { PartnershipSection } from '../components/home/PartnershipSection';
import { VerhuisServices } from '../components/home/VerhuisServices';
import { RecentProjects } from '../components/home/RecentProjects';
import { GoogleReviews } from '../components/home/GoogleReviews';
import { FAQSection } from '../components/home/FAQSection';
import { SEO } from '../components/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Fitnessapparatuur verhuizen in heel Nederland | Nexon Installatie & Service"
        description="Specialist in fitnessapparatuur verhuizen, transport, demontage en montage in heel Nederland. Technogym, loopbanden, crosstrainers en krachtstations. 5+ jaar ervaring. Vraag een gratis offerte aan."
        path="/"
      />
      <Header />
      <main>
        <HeroSection />
        <ServicesOverview />
        <VerhuisServices />
        <RecentProjects />
        <ClientTypesSection />
        <PartnershipSection />
        <FAQSection />
        <GoogleReviews />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
